import { TagsStack } from 'ui-components'
import { useMap } from '~map-preview/states/map'

export function MapDescriptionTags() {
  const { mapTagCollection } = useMap()
  return <TagsStack items={mapTagCollection.items} />
}
